module.exports = __webpack_public_path__ + "img/search.2a32b3b3.svg";